<div class="lock-screen-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="daxa-form ml-auto mr-auto border-radius bg-white"
                [class.card-borderd-theme]="themeService.isCardBorder()"
                [class.component-dark-theme]="themeService.isDark()">
                <div class="title text-center">
                    <h3>
                        Welcome To {{ (tenant$ | async)?.name || 'Our Institution' }}.
                    </h3>
                    <p class="ml-auto mr-auto">
                        Enter your username & password to gain back access.
                    </p>
                </div>
                <div class="admin text-center">
                    <img [src]="(tenant$ | async)?.logoUrl " class="" alt="admin-image">
                    <h3 class="d-block ">
                        Lock Screen
                    </h3>
                    <span class="d-block fw-medium">
                        {{currentUser?.displayName??""}}
                    </span>
                </div>
                <form [formGroup]="authForm" (ngSubmit)="onSubmit()">
                    <div class="form-group">
                        <label class="main-label d-block lh-1 text-black">
                            Username
                        </label>
                        <mat-form-field appearance="fill">
                            <mat-label>
                                Enter username
                            </mat-label>
                            <input matInput type="text" id="username" formControlName="username" />
                        </mat-form-field>
                        <div class="error text-danger"
                            *ngIf="authForm.get('username')!.hasError('required') && authForm.get('username')!.touched">
                            username/email is required.
                        </div>

                    </div>
                    <div class="form-group">
                        <label class="main-label d-block lh-1 text-black">
                            Password
                        </label>
                        <mat-form-field appperance="fill">
                            <mat-label>
                                Enter password
                            </mat-label>
                            <input matInput [type]="hide ? 'password' : 'text'" id="password"
                                formControlName="password">
                            <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                                [attr.aria-pressed]="hide">
                                <span class="material-symbols-outlined">
                                    {{hide ? 'visibility_off' : 'visibility'}}
                                </span>
                            </button>
                        </mat-form-field>
                        <div class="error text-danger"
                            *ngIf="authForm.get('password')!.hasError('required') && authForm.get('password')!.touched">
                            Password is required.
                        </div>

                    </div>
                    <button mat-button class="btn" type="submit" [disabled]="authForm.invalid||unlocking">
                        {{unlocking?"Unlocking...":"Unlock"}}
                    </button>
                </form>
            </div>
        </div>
    </div>
</div>